import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    background-color:  ${({ theme }) => theme.menuBackground};

    @media (max-width: 900px) {
      height: 100%;
    }

    @media (max-width: 900px) and (min-height: 775px) {
      height: 100vh;
    }

    @media (min-width: 550px) and (max-height: 656px) {
      height: 100%;
    }
    
    @media (max-width: 1350px) and (max-height: 656px) and (min-width: 900px) {
      height: 100vh;
    }
`;

export const Content = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.menuHover};

  @media (max-width: 900px) {
    padding: 30px 0;
  }

  main, aside {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: auto;
    align-items: center;
    justify-content: center;
    text-align: center;

    h1 {
      font-weight: bold;
      font-size: 1.4rem;
      text-transform: uppercase;
      letter-spacing: 2px;
      margin: 0 100px 40px;
      color: ${({ theme }) => theme.text};
    }

    button {
    border: none;
    background-color:  ${({ theme }) => theme.purple};
    height: 70px;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);

    color: ${({ theme }) => theme.white};
    font-size: 1.3rem;
    letter-spacing: 2px;
    text-transform: uppercase;

      :hover {
        filter: brightness(1.2);
        transition: 0.3s;
      }
    }

    img {
      width: 60%;
    }
  }

  aside {
    height: 100%;
  }

  @media (max-width: 1050px) {
    main {
      flex: 6
    }

    aside {
      flex: 4;

      img {
        width: 70%;
      }
    }
  }

  @media (max-width: 900px) {
    main {
      flex: 7
    }

    aside {
      flex: 3;

      img {
        width: 100%;
      }
    }
  }

  @media (max-width: 1050px) {
    aside {
      display: none;
    }
  }

  @media (min-width: 500px) {
    button {
      width: 50%;
    }
  }

  @media (max-width: 500px) {
    h1, button {
      width: 80%;
    }
  }
`;

export const FormWrapper = styled.div`
  width: 50%;
  margin: auto;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);
  padding: 20px 20px 10px 20px;
  text-align: start;

  @media (max-width: 500px) {
    width: 80%;
  }

  label {
    letter-spacing:0.05rem;
    font-weight:bold;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.black};
  }
`;